function isJSON(data) {
    try {
        JSON.parse(data);
    }
    catch (error) {
        try {
            if (JSON.stringify(data)[0] !== '{') {
                return false;
            }
        }
        catch (error) {
            return false;
        }
        return true;
    }
    return true;
}
function toJSON(data) {
    try {
        return JSON.parse(data);
    }
    catch (error) {
        return data;
    }
}

export { isJSON, toJSON };
